/**
 * @generated SignedSource<<ba32b7205401cfdd45f7a93e26999db1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MediaType = "cast" | "ins_highlight" | "ins_image" | "ins_live" | "ins_reel_story" | "ins_story" | "ins_video" | "other" | "tiktok" | "tiktok_go" | "twitter_image" | "twitter_video" | "youtube" | "youtube_short";
export type ParentMediaType = "cast" | "instagram" | "other" | "tiktok" | "tiktok_go" | "twitter" | "youtube";
import { FragmentRefs } from "relay-runtime";
export type SNSBadge_mediaType$data = {
  readonly mediaType: MediaType;
  readonly parentMediaType: ParentMediaType;
  readonly " $fragmentType": "SNSBadge_mediaType";
};
export type SNSBadge_mediaType$key = {
  readonly " $data"?: SNSBadge_mediaType$data;
  readonly " $fragmentSpreads": FragmentRefs<"SNSBadge_mediaType">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SNSBadge_mediaType",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parentMediaType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mediaType",
      "storageKey": null
    }
  ],
  "type": "Campaign",
  "abstractKey": null
};

(node as any).hash = "a88953796745c5d66984440625bde397";

export default node;
